/* eslint-disable max-len */
import React, { useState, useEffect, useCallback, useContext } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { dataService } from "../../../../services/data.services";
import Pagination from "../../../../components/Pagination";
import StatusIndicator from "../../../../components/StatusIndicator";
import ItemShimmer from "../../../../components/Shimmer/itemShimmer";
import { ConvertToTitleCase } from "../../../../CommonMethods/ConvertToTitleCase";
import Button from "../../../../components/Button";
import GlobalContext from "../../../../components/Context/GlobalContext";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Confirmationpopup from "../../../manageAdminUser/components/Confirmationpopup";
import { Tooltip } from 'react-tooltip'
import Noresult from "../Noresult";
import { checkPrivilege } from "../../../../CommonMethods/checkPrivilege";

export default function EmployeeTable({ viewData, isUpdated, setIsUpdated }) {
    const navigate = useNavigate();
    const { setToastmessage } = useContext(GlobalContext)
    const { setToastErrorMessage } = useContext(GlobalContext)
    const [activateLoading, setactivateLoading] = useState(false)
    const [list, setList] = useState({})
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [search,setSearch] = useState('')
    const [timer,setTimer] = useState(0)
    const [loading, setLoading] = useState(true);
    const [modalpopup, setmodalpopup] = useState({})
    const [searchQuery, setSearchQuery] = useState("");
    const [showSearch,setShowSearch] = useState('')
    const [filterParams, setfilterParams] = useState({
        page_number: 1,
        sort: ''
    })

    const [importLoading, setIsImportLoading] = useState(false);

    const { page_number, sort } = filterParams

    const toggleSearch = () => {
        setIsSearchVisible(!isSearchVisible);
    };

    const handleOnClickSearch = (value) => {
        setSearchQuery(value)
    }
    const handleSearch = (newValue) => {
        setShowSearch(newValue)
        clearTimeout(timer); // Clear the previous timer
        const newTimer = setTimeout(() => {
            handleOnClickSearch(newValue); // Call the function after 500 milliseconds
        }, 500);
        setTimer(newTimer); // Set the new timer
    }
    const getData =
        useCallback(
            async (key) => {
                try {
                    const encodedEmail = encodeURIComponent(viewData.email_address);
                    const encodeSearch = encodeURIComponent(searchQuery)
                    // eslint-disable-next-line max-len
                    let res = await dataService.GetAPI(`employees/list?page_number=${filterParams.page_number}${sort == '' ? '' : `&sort=${sort}`}&merchant=${encodedEmail}${searchQuery !== '' ? `&search=${encodeSearch}` : ''}`);
                    console.log(res)
                    setList(res.data);
                    setLoading(false)
                } catch (error) {
                    setToastErrorMessage(error.message)
                }
            },
            [page_number, sort, isUpdated, searchQuery],
        )

    useEffect(() => {
        getData()
    }, [getData, setmodalpopup])

    const handlePagination = (pageNum) => {
        setLoading(true);
        setfilterParams((prv) => ({
            ...prv,
            "page_number": pageNum.selected + 1
        }))
    }

    const handleSort = (key) => {
        setLoading(true)
        if (sort === '') {
            setfilterParams((prv) => ({
                ...prv,
                "sort": `${key}+asc`
            }))
        }
        else {
            let newKey = sort.endsWith('+desc') ? `${key}+asc` : `${key}+desc`
            setfilterParams((prv) => ({
                ...prv,
                "sort": newKey
            }))
            // getData(newKey)

        }
    }

    const [exportLoader, setexportLoader] = useState(false)
    const handleExport = async () => {
        setexportLoader(true);

        // eslint-disable-next-line max-len
        const res = await dataService.GetAPI(`employees/export-csv?merchant=${encodeURIComponent(viewData.email_address)}${sort == '' ? '' : `&sort=${sort}`}`);
        if (!res.error) {
            window.open(
                res.data.url,
                '_blank'
            );
            // window.location.href = res.data.url
            setToastmessage('File Exported Successfully');
            setexportLoader(false)
        }

    }

    const handleActivate = async () => {
        setactivateLoading(true)
        const body = {
            status: modalpopup.status === true ? 'false' : 'true'
        }
        try {
            const email = encodeURIComponent(modalpopup['email_address']);
            const res = await dataService.PatchAPI(body, `employees/activate-deactivate/${modalpopup['_id']}`);
            if (!res.error) {
                setToastmessage(`Employee ${modalpopup.status === true ? 'deactivated' : 'activated'} successfully`)
                setactivateLoading(false);
                setmodalpopup({});
                // getAdminUserList()
                setIsUpdated(!isUpdated)
                // handleFetch()

            } else {
                setToastErrorMessage(res.data.message);
                setactivateLoading(false);

            }

        } catch (error) {
            setToastErrorMessage(error.response.data.message);
            setactivateLoading(false);
            setmodalpopup({})
        }
    }

    const handleClose = () => {
        setmodalpopup({});
        setactivateLoading(false)
    }

    const handleImport = () => {
        navigate(`/manage-merchants/${viewData['email_address']}/import-employee`);
    }

    const CheckSort = (key) => filterParams['sort'] !== null && filterParams['sort'] === `${key}+asc`
    const hasAddEmployee = checkPrivilege('add_employee');
    const hasUpdateEmployee = checkPrivilege('update_employee')
    const hasActivateEmployee = checkPrivilege('activate_or_deactivate_employee')
    return (
        <div>
            <div className=" pt-8 pb-6 flex justify-between">
                <p className="  text-xl font-medium text-[#4B4B4B]">Employee</p>
                <div className="flex space-x-[25px] pr-[30px] items-center">
                    <div className="relative mr-[20px] h-[42px]">
                        <input
                            type="text"
                            // value={searchParams.search}
                            value={showSearch}
                            data-testid="emp-search"
                            onChange={(e)=>handleSearch(e.target.value)}
                            placeholder="Employee Name, Email Address"
                            className={`w-[314px]  rounded-[8px] pr-10 pl-[14px] py-2 z-1 border border-[#8E8E8E] placeholder:text-sm placeholder:font-normal placeholder:text-[#1F1F1F] outline-none ${isSearchVisible ? 'block' : 'hidden'}`}

                        />
                        <img
                            src="/assets/images/search.svg"
                            alt=""
                            onClick={toggleSearch}
                            data-testid='emp-search-btn'
                            // className="absolute top-[11px] right-[19px]"
                            className={`${isSearchVisible ? 'absolute top-[12px]  right-4' : 'mr-4 mt-[12px]'}   `}
                        />
                    </div>
                    {hasAddEmployee && <div className="relative" data-tooltip-id="my-tooltip-8">
                        <img
                            src="/assets/images/plus.svg"
                            className="cursor-pointer hover:bg-[#EB9DC7] p-3 rounded-full"
                            alt="add"
                            onClick={() =>
                                navigate(
                                    `/manage-merchants/${viewData.email_address}/${viewData._id}/add-employee`
                                )
                            }
                            data-testid="add-employee"
                        />
                        {/* <p className="w-fit bg-black text-white text-xs font-semibold 
                    px-2 py-1 opacity-0 add_msg absolute bottom-11 -left-4 rounded-md whitespace-nowrap">
                            Add Employee
                        </p> */}
                        <Tooltip
                            id="my-tooltip-8"
                            place="top"
                            content="Add Employee"
                        />
                    </div>}
                    <Button
                        handleClick={handleImport}
                        loading={importLoading}
                        disabled={importLoading}
                        text="Import"
                        classKey="px-4 py-[10px] border border-primary text-primary rounded-[12px]"
                        type="button"
                        testId="import-employee-btn"
                        color="#9C2363"
                    />
                    <Button
                        handleClick={handleExport}
                        loading={exportLoader}
                        disabled={exportLoader}
                        text="Export"
                        classKey="px-4 py-[10px] border border-primary text-primary rounded-[12px]"
                        type="button"
                        testId="export"
                        color="#9C2363"
                    />
                </div>
            </div>
            <div>
                <>
                    {loading ?
                        <ItemShimmer />
                        :
                        <>
                            {!loading && list?.data.length > 0 && (
                                <div data-testid="employee-table" className="pr-5">
                                    <table className="w-full">
                                        <thead>
                                            <tr className="border-b-[1px] border-[#EEEEEE]">
                                                <th className="flex space-x-1 px-4 py-3">
                                                    <h1 className="text-sm text-[#4B4B4B] font-medium">Employee Name</h1>
                                                    <img src="/assets/images/sort-pink.svg" alt="" onClick={() => handleSort('name')}
                                                        className={`cursor-pointer ${CheckSort('status') ? 'rotate-180' : ''}`} data-testid="employee-sort_name" />
                                                </th>
                                                <th className="px-4 py-3 text-left">
                                                    <h1 className="text-sm text-[#4B4B4B] font-medium text-left">Email Address</h1>
                                                </th>
                                                <th className="px-4 py-3">
                                                    <h1 className="text-sm text-[#4B4B4B] font-medium text-left">Phone Number</h1>
                                                </th>
                                                <th className="px-4 py-3">
                                                    <h1 className="text-sm text-[#4B4B4B] font-medium text-left">Store</h1>
                                                </th>
                                                <th className="flex space-x-1 px-4 py-3 text-start">
                                                    <h1 className="text-sm text-[#4B4B4B] font-medium">Status</h1>
                                                    <img src="/assets/images/sort-pink.svg" alt="" onClick={() => handleSort('status')}
                                                        className={`cursor-pointer ${CheckSort('status') ? 'rotate-180' : ''}`} data-testid="employee-sort_status" />
                                                </th>
                                                <th className="px-4 py-3">
                                                    <h1 className="text-sm text-[#4B4B4B] font-medium">Action</h1>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!loading && list?.data.map((item, index) => (
                                                <tr key={index} className="border-b-[1px] border-[#EEEEEE]">
                                                    <td className="px-4 py-3">
                                                        <h1 title={item.name} className="text-sm text-[#4B4B4B] font-normal text-left max-w-[150px] text-ellipsis overflow-hidden whitespace-nowrap">
                                                            {item.name}
                                                        </h1>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <h1 title={item.email_address} className="text-sm text-[#4B4B4B] font-normal text-left max-w-[200px] text-ellipsis overflow-hidden whitespace-nowrap">
                                                            {item.email_address}
                                                        </h1>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <h1 title={item.phone_number} className="text-sm text-[#4B4B4B] font-normal text-left max-w-[150px] text-ellipsis overflow-hidden whitespace-nowrap">
                                                            {item.phone_number}
                                                        </h1>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <h1 title={item.store} className="text-sm text-[#4B4B4B] font-normal text-left max-w-[150px] text-ellipsis overflow-hidden whitespace-nowrap">{item.store}</h1>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        {item.status !== '' ? (
                                                            <StatusIndicator item={item} hasPrivilege={hasActivateEmployee} setmodalpopup={setmodalpopup} status={item.status === true ? 'true' : 'false'} testid={`emp-toggle-btn-${index}`} />

                                                        ) : (
                                                            '-'
                                                        )}
                                                    </td>
                                                    <td className={`px-4 py-3 flex justify-center items-center`} onClick={() => {
                                                        if (hasUpdateEmployee) {
                                                            navigate(`/manage-merchants/${viewData.email_address}/edit-employee/${item._id}`)
                                                        }
                                                    }}>
                                                        {/* <Link to={`/manage-merchant/${viewData.email_address}/edit-employee/${item._id}`}> */}
                                                        <div className={`relative ${hasUpdateEmployee ? 'cursor-pointer' : 'cursor-not-allowed'}`} data-tooltip-id="my-tooltip-9">
                                                            <img src="/assets/images/Edit.svg" alt="" data-testid="emp_edit" className={`${hasUpdateEmployee ? 'cursor-pointer' : 'cursor-not-allowed'}`} />
                                                            <p className="w-fit bg-black text-white text-base font-semibold px-2 py-1 opacity-0 add_msg absolute -top-2 left-6 rounded-md">
                                                                Edit
                                                            </p>
                                                            <Tooltip id="my-tooltip-9" place="right" content="Edit" />
                                                        </div>
                                                        {/* </Link> */}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {!loading && Math.ceil(list?.total_count / 10) > 1 && (
                                        <Pagination
                                            selectedPageNumber={filterParams.page_number}
                                            handleOnClickPageNumber={handlePagination}
                                            TotalCount={list?.total_count}
                                            totalPageNumber={Math.ceil(list?.total_count / 10)}
                                        />
                                    )}
                                </div>
                            )}
                            <>{!loading && list?.data.length === 0 && (<Noresult title="No employees available" subtitle="Click on the button below to add employee" path={`/manage-merchants/${viewData.email_address}/${viewData._id}/add-employee`} />)}</>
                        </>}</>
            </div>
            <Modal open={Object.keys(modalpopup).length > 0} onClose={handleClose}>
                <Confirmationpopup
                    message={`Are you sure you want to ${modalpopup.status === true ? 'deactivate' : 'activate'} the employee ${modalpopup.name}? `}
                    Title={`${modalpopup.status === true ? 'Deactivate' : 'Activate'} Employee`}
                    handleSubmit={handleActivate}
                    stateKey={`${modalpopup.status === true ? 'Deactivate' : 'Activate'}`}
                    loading={activateLoading}
                    handleClose={handleClose}
                //content={`The deactivation of this store will result in deactivation of all employees associated with it.`}
                />

            </Modal>
        </div>
    )
}
